import * as signalR from "@microsoft/signalr";
import { createApiUrl } from "@/lib/api/create-api-url";
import { useAuthStore } from "@/lib/auth/auth-store";

export function createHubConnection(): signalR.HubConnection {
  const hubUrl = createApiUrl("/hubs/user");

  return new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: async () => {
        const { getAccessTokenSilently } = useAuthStore.getState();
        if (!getAccessTokenSilently) return "";
        return getAccessTokenSilently();
      },
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Warning)
    .build();
}
